<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">礼物配置</h1>
    <div :gutter="20" class="user-options">
      礼物名称:
      <el-input v-model="giftName" style="width: 160px" clearable placeholder="请输入内容"></el-input>
      礼物类型:
      <el-select style="width: 160px" class="header-item" v-model="isLuckGift" placeholder="">
        <el-option v-for="(item, itemIndex) in isLuckGifts" :key="itemIndex" :label="item.label"
          :value="item.value"></el-option>
      </el-select>
      礼物场景:
      <el-select style="width: 160px" class="header-item" v-model="giftType" placeholder="">
        <el-option v-for="(item, itemIndex) in giftTypes" :key="itemIndex" :label="item.label"
          :value="item.value"></el-option>
      </el-select>
      礼物状态:
      <el-select style="width: 160px" class="header-item" v-model="vail" placeholder="">
        <el-option v-for="(item, itemIndex) in vails" :key="itemIndex" :label="item.label"
          :value="item.value"></el-option>
      </el-select>
      渠道:
      <el-select v-model="channel" placeholder="请选择渠道" clearable="" filterable>
        <el-option v-for="(item, itemIndex) in channelList" v-bind:key="itemIndex" :label="item.label"
          :value="item.value"></el-option>
      </el-select>
      是否活动礼物:
      <el-select v-model="activity" placeholder="是否活动礼物" clearable="" filterable>
        <el-option label="不是" value="0"></el-option>
        <el-option label="是" value="1"></el-option>
      </el-select>
        是否显示活动标签:
        <el-select v-model="activityLabel" placeholder="是否活动礼物" clearable="" filterable>
          <el-option label="不是" value="0"></el-option>
          <el-option label="是" value="1"></el-option>
        </el-select>
      礼物ID:
      <el-input v-model="giftId" style="width: 160px" placeholder="礼物ID" clearable></el-input>
      定制礼物绑定RID:
      <el-input v-model="customizedRid" style="width: 160px" placeholder="定制礼物绑定RID" clearable></el-input>
      价格排序:
      <el-select style="width: 160px" class="header-item" v-model="priceOrder">
        <el-option v-for="(item, itemIndex) in priceOrderType" :key="itemIndex" :label="item.label"
          :value="item.value"></el-option>
      </el-select>
      排序:
      <el-select style="width: 160px" class="header-item" v-model="orderId">
        <el-option v-for="(item, itemIndex) in orderlist" :key="itemIndex" :label="item.label"
          :value="item.value"></el-option>
      </el-select>
      显示类型:
      <el-select style="width: 160px" class="header-item" v-model="showType">
        <el-option v-for="(item, itemIndex) in showTypeList" :key="itemIndex" :label="item.name"
          :value="item.value"></el-option>
      </el-select>
      礼物类型:
      <el-select style="width: 160px" class="header-item" v-model="giftTypelist" multiple>
        <el-option v-for="(item, itemIndex) in giftTypelists" :key="itemIndex" :label="item.label"
          :value="item.value"></el-option>
      </el-select>
      加载类型:
      <el-select style="width: 160px" class="header-item" v-model="loadType">
        <el-option v-for="(item, itemIndex) in showLoadList" :key="itemIndex" :label="item.name"
          :value="item.value"></el-option>
      </el-select>
      <el-button type="warning" @click="getDayChatDetai" :loading="login1">
        查询
      </el-button>
      <el-button type="success" @click="cre"> 创建 </el-button>
      <el-popconfirm title="确定批量编辑吗？" @confirm="moreEdit">
        <el-button slot="reference" type="success"> 批量编辑 </el-button>
      </el-popconfirm>
      <el-popconfirm title="确定批量上架吗？" @confirm="moreChangeEdit(1)">
        <el-button slot="reference" type="success"> 批量上架 </el-button>
      </el-popconfirm>
      <el-popconfirm title="确定批量下架吗？" @confirm="moreChangeEdit(0)">
        <el-button slot="reference" type="success"> 批量下架 </el-button>
      </el-popconfirm>
      <el-button type="info" v-if="isText === 1" @click="dialogVisible = true">导入</el-button>
    </div>
    <!-- 创建弹窗 -->
    <el-drawer title="创建" size="40%" :visible.sync="drawer" :direction="direction" :before-close="handleClose">
      <div class="add">
        <div v-if="est">
          <el-row>
            <el-col class="el-cols">
              <span>渠道:</span>
              <el-select v-model="list.channelList" placeholder="请选择渠道" clearable="" filterable multiple>
                <el-option v-for="(item, itemIndex) in channelList" v-bind:key="itemIndex" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
              <el-checkbox style="margin-left: 10px" v-model="checked">all</el-checkbox>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>礼物类型:</span>
              <el-select style="width: 160px" v-model="list.isLuck" placeholder="">
                <el-option v-for="(item, itemIndex) in giftsTypeList" v-bind:key="itemIndex" :label="item.name"
                  :value="item.value"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>礼物名字:</span>
              <el-input v-model="list.giftName" style="width: 160px" placeholder="请输入"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>礼物价格:</span>
              <el-input v-model="list.realPrice" style="width: 160px" placeholder="请输入"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>显示分类:</span>
              <el-select style="width: 160px" class="header-item" v-model="list.showType">
                <el-option v-for="(item, itemIndex) in showTypeList" :key="itemIndex" :label="item.name"
                  :value="item.value"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>礼物排序权重:</span>
              <el-input type="number" v-model="list.orderId" style="width: 160px" placeholder="请输入"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>加载类型:</span>
              <el-select style="width: 160px" class="header-item" v-model="list.loadType">
                <el-option v-for="(item, itemIndex) in showLoadList" :key="itemIndex" :label="item.name"
                  :value="item.value"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>是否上架:</span>
              <el-switch v-model="list.vail" active-text="上架" inactive-text="下架" :active-value="1"
                :inactive-value="0"></el-switch>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>礼物图标:</span>
              <UploadSingleImg v-model="list.iconUrl" :on-upload="(file) => uploadFile(file, ' gift_resource/icon/')" />
              <span class="url" v-if="list.iconUrl">{{ list.iconUrl }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>礼物资源:</span>
              <UploadSingleImg v-model="list.resourceUrl"
                :on-upload="(file) => uploadFile(file, ' gift_resource/gift/')" />
              <span class="url" v-if="list.resourceUrl">{{ list.resourceUrl }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>礼物动画资源:</span>
              <UploadSingleImg v-model="list.originUrl"
                :on-upload="(file) => uploadFile(file, ' gift_resource/origin/')" />
              <span class="url" v-if="list.originUrl">{{ list.originUrl }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>融合礼物资源:</span>
              <UploadSingleImg v-model="list.fusionUrl"
                :on-upload="(file) => uploadFile(file, ' gift_resource/fusion/')" />
              <span class="url" v-if="list.fusionUrl">{{ list.fusionUrl }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>礼物动画时间:</span>
              <el-input type="number" v-model="list.len" style="width: 160px" placeholder="请输入"></el-input>
            </el-col>
          </el-row>
          <el-row style="margin-top: 50px;">
            <el-col class="el-cols">
              <span>礼物属性:</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols" :span="12">
              <span>是否活动礼物:</span>
              <el-switch v-model="list.activity" active-text="是" inactive-text="不是" :active-value="1"
                :inactive-value="0"></el-switch>
            </el-col>
          </el-row>
          <el-row>
            <div class="el-cols">
              <span>是否融合礼物:</span>
              <el-switch v-model="list.fusionSwitch" active-text="是" inactive-text="不是" :active-value="1"
                :inactive-value="0"></el-switch>
            </div>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>融合礼物头像类型:</span>
              <el-radio-group v-model="list.fusionType">
                <el-radio :label="0">不是</el-radio>
                <el-radio :label="1">单头像</el-radio>
                <el-radio :label="2">双头像</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>融合礼物展示对象:</span>
              <el-radio-group v-model="list.fusionShowType">
                <el-radio :label="1">发送者</el-radio>
                <el-radio :label="2">接收者</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>是否昵称展示:</span>
              <el-switch v-model="list.fusionNameSwitch" active-text="是" inactive-text="不是" :active-value="1"
                :inactive-value="0"></el-switch>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>是否id展示:</span>
              <el-switch v-model="list.fusionIdSwitch" active-text="是" inactive-text="不是" :active-value="1"
                :inactive-value="0"></el-switch>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>rid色值:</span>
              <el-input v-model="list.idColor" style="width: 160px" placeholder="请输入"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>昵称色值:</span>
              <el-input v-model="list.nameColor" style="width: 160px" placeholder="请输入"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>是否贵族:</span>
              <el-switch v-model="list.lord" active-text="是" inactive-text="不是" :active-value="1"
                :inactive-value="0"></el-switch>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>是否VIP:</span>
              <el-switch v-model="list.vip" active-text="是" inactive-text="不是" :active-value="1"
                :inactive-value="0"></el-switch>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>是否表白礼物:</span>
              <el-switch v-model="list.confession" active-text="是" inactive-text="不是" :active-value="1"
                :inactive-value="0"></el-switch>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>是否上公告:</span>
              <el-select style="width: 160px" v-model="list.bulletin" placeholder="">
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="0"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>是否显示活动标签:</span>
              <el-select style="width: 160px" v-model="list.activityLabel" placeholder="">
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="0"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>等级:</span>
              <el-input type="number" v-model="list.level" style="width: 160px" placeholder="请输入"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>是否SVIP礼物:</span>
              <el-switch v-model="list.svip" active-text="是" inactive-text="不是" :active-value="1"
                :inactive-value="0"></el-switch>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <span>送礼场景:</span>
            </el-col>
          </el-row>
          <div class="row" style="width: 100%;">
            <!-- <div>
              <el-checkbox v-model="table_ceck[0].checkList" label="私聊"></el-checkbox>
              <div>
                <span>礼物分成:</span>
                <el-input type="number" v-model="table_ceck[0].gainRatio" style="width: 160px" placeholder="请输入"
                  size="mini"></el-input>
              </div>
              <div>
                <span>是否快捷礼物:</span>
                <el-switch v-model="table_ceck[0].isFast" active-text="是" inactive-text="不是" :active-value="1"
                  :inactive-value="0"></el-switch>
              </div>
              <div>
                <span>快捷发送数量(例：18;88;88):</span>
                <el-input type="text" v-model="table_ceck[0].fastNums" style="width: 160px"
                  placeholder="请输入"></el-input>
              </div>
              <div>
                <span>是否展示礼物描述:</span>
                <el-switch v-model="table_ceck[0].showGiftDesc" active-text="展示" inactive-text="不展示" :active-value="1"
                  :inactive-value="0"></el-switch>
              </div>
              <div>
                <span>礼物描述:</span>
                <el-input type="text" v-model="table_ceck[0].giftDesc" style="width: 160px"
                  placeholder="请输入"></el-input>
              </div>
              <el-row>
                <el-col class="el-cols">
                  <span>礼物图片url:</span>
                  <el-input v-model="table_ceck[0].giftDescIconUrl" style="width: 160px" placeholder="请输入"></el-input>
                </el-col>
              </el-row>
              <div>
                <span>礼物描述跳转的链接:</span>
                <el-input type="text" v-model="table_ceck[0].giftDescUrl" style="width: 160px"
                  placeholder="请输入"></el-input>
              </div>
              <div>
                <span>是否全屏特效:</span>
                <el-switch v-model="table_ceck[0].screenEffect" active-text="是" inactive-text="不是" :active-value="1"
                  :inactive-value="0"></el-switch>
              </div>
              <div>
                <span>是否全服通知:</span>
                <el-switch v-model="table_ceck[0].serverNotification" active-text="是" inactive-text="不是"
                  :active-value="1" :inactive-value="0"></el-switch>
              </div>
              <div>
                <span>主播端展示:</span>
                <el-switch v-model="table_ceck[0].hostShow" active-text="展示" inactive-text="不展示" :active-value="1"
                  :inactive-value="0"></el-switch>
              </div>
            </div>
            <div>
              <el-checkbox v-model="table_ceck[1].checkList" label="视频通话"></el-checkbox>
              <div>
                <span>礼物分成:</span>
                <el-input type="number" v-model="table_ceck[1].gainRatio" style="width: 160px" placeholder="请输入"
                  size="mini"></el-input>
              </div>
              <div>
                <span>是否快捷礼物:</span>
                <el-switch v-model="table_ceck[1].isFast" active-text="是" inactive-text="不是" :active-value="1"
                  :inactive-value="0"></el-switch>
              </div>
              <div>
                <span>快捷发送数量(例：18;88;88):</span>
                <el-input type="text" v-model="table_ceck[1].fastNums" style="width: 160px"
                  placeholder="请输入"></el-input>
              </div>
              <div>
                <span>是否展示礼物描述:</span>
                <el-switch v-model="table_ceck[1].showGiftDesc" active-text="展示" inactive-text="不展示" :active-value="1"
                  :inactive-value="0"></el-switch>
              </div>
              <div>
                <span>礼物描述:</span>
                <el-input type="text" v-model="table_ceck[1].giftDesc" style="width: 160px"
                  placeholder="请输入"></el-input>
              </div>
              <el-row>
                <el-col class="el-cols">
                  <span>礼物图片url:</span>
                  <el-input v-model="table_ceck[1].giftDescIconUrl" style="width: 160px" placeholder="请输入"></el-input>
                </el-col>
              </el-row>
              <div>
                <span>礼物描述跳转的链接:</span>
                <el-input type="text" v-model="table_ceck[1].giftDescUrl" style="width: 160px"
                  placeholder="请输入"></el-input>
              </div>
              <div>
                <span>是否全屏特效:</span>
                <el-switch v-model="table_ceck[1].screenEffect" active-text="是" inactive-text="不是" :active-value="1"
                  :inactive-value="0"></el-switch>
              </div>
              <div>
                <span>是否全服通知:</span>
                <el-switch v-model="table_ceck[1].serverNotification" active-text="是" inactive-text="不是"
                  :active-value="1" :inactive-value="0"></el-switch>
              </div>
              <div>
                <span>主播端展示:</span>
                <el-switch v-model="table_ceck[1].hostShow" active-text="展示" inactive-text="不展示" :active-value="1"
                  :inactive-value="0"></el-switch>
              </div>
            </div>
            <div>
              <el-checkbox v-model="table_ceck[3].checkList" label="live"></el-checkbox>
              <div>
                <span>礼物分成比:</span>
                <el-input type="number" v-model="table_ceck[3].gainRatio" style="width: 160px" placeholder="请输入"
                  size="mini"></el-input>
              </div>
              <div>
                <span>是否快捷礼物:</span>
                <el-switch v-model="table_ceck[3].isFast" active-text="是" inactive-text="不是" :active-value="1"
                  :inactive-value="0"></el-switch>
              </div>
              <div>
                <span>快捷发送数量(例：18;88;88):</span>
                <el-input type="text" v-model="table_ceck[3].fastNums" style="width: 160px"
                  placeholder="请输入"></el-input>
              </div>
              <div>
                <span>是否展示礼物描述:</span>
                <el-switch v-model="table_ceck[3].showGiftDesc" active-text="展示" inactive-text="不展示" :active-value="1"
                  :inactive-value="0"></el-switch>
              </div>
              <div>
                <span>礼物描述:</span>
                <el-input type="text" v-model="table_ceck[3].giftDesc" style="width: 160px"
                  placeholder="请输入"></el-input>
              </div>
              <el-row>
                <el-col class="el-cols">
                  <span>礼物图片url:</span>
                  <el-input v-model="table_ceck[3].giftDescIconUrl" style="width: 160px" placeholder="请输入"></el-input>
                </el-col>
              </el-row>
              <div>
                <span>礼物描述跳转的链接:</span>
                <el-input type="text" v-model="table_ceck[3].giftDescUrl" style="width: 160px"
                  placeholder="请输入"></el-input>
              </div>
              <div>
                <span>是否全屏特效:</span>
                <el-switch v-model="table_ceck[3].screenEffect" active-text="是" inactive-text="不是" :active-value="1"
                  :inactive-value="0"></el-switch>
              </div>
              <div>
                <span>是否全服通知:</span>
                <el-switch v-model="table_ceck[3].serverNotification" active-text="是" inactive-text="不是"
                  :active-value="1" :inactive-value="0"></el-switch>
              </div>
              <div>
                <span>主播端展示:</span>
                <el-switch v-model="table_ceck[3].hostShow" active-text="展示" inactive-text="不展示" :active-value="1"
                  :inactive-value="0"></el-switch>
              </div>
            </div>
            <div>
              <el-checkbox v-model="table_ceck[4].checkList" label="房间礼物"></el-checkbox>
              <div>
                <span>礼物分成比:</span>
                <el-input type="number" v-model="table_ceck[4].gainRatio" style="width: 160px" placeholder="请输入"
                  size="mini"></el-input>
              </div>
              <div>
                <span>是否快捷礼物:</span>
                <el-switch v-model="table_ceck[4].isFast" active-text="是" inactive-text="不是" :active-value="1"
                  :inactive-value="0"></el-switch>
              </div>
              <div>
                <span>快捷发送数量(例：18;88;88):</span>
                <el-input type="text" v-model="table_ceck[4].fastNums" style="width: 160px"
                  placeholder="请输入"></el-input>
              </div>
              <div>
                <span>是否展示礼物描述:</span>
                <el-switch v-model="table_ceck[4].showGiftDesc" active-text="展示" inactive-text="不展示" :active-value="1"
                  :inactive-value="0"></el-switch>
              </div>
              <div>
                <span>礼物描述:</span>
                <el-input type="text" v-model="table_ceck[4].giftDesc" style="width: 160px"
                  placeholder="请输入"></el-input>
              </div>
              <el-row>
                <el-col class="el-cols">
                  <span>礼物图片url:</span>
                  <el-input v-model="table_ceck[4].giftDescIconUrl" style="width: 160px" placeholder="请输入"></el-input>
                </el-col>
              </el-row>
              <div>
                <span>礼物描述跳转的链接:</span>
                <el-input type="text" v-model="table_ceck[4].giftDescUrl" style="width: 160px"
                  placeholder="请输入"></el-input>
              </div>
              <div>
                <span>是否全屏特效:</span>
                <el-switch v-model="table_ceck[4].screenEffect" active-text="是" inactive-text="不是" :active-value="1"
                  :inactive-value="0"></el-switch>
              </div>
              <div>
                <span>是否全服通知:</span>
                <el-switch v-model="table_ceck[4].serverNotification" active-text="是" inactive-text="不是"
                  :active-value="1" :inactive-value="0"></el-switch>
              </div>
              <div>
                <span>主播端展示:</span>
                <el-switch v-model="table_ceck[4].hostShow" active-text="展示" inactive-text="不展示" :active-value="1"
                  :inactive-value="0"></el-switch>
              </div>
            </div> -->
            <div v-for="(item, index) in giftTypes.slice(1)" style="width: 100%;padding: 0 20px;" :key="index">
              <el-card style="width: 100%;">
                <el-row>
                  <el-col class="el-cols">
                    <el-checkbox v-model="table_ceck[index].checkList" :label="item.label"></el-checkbox>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="el-cols">
                    <span>礼物分成比:</span>
                    <el-input type="number" v-model="table_ceck[index].gainRatio" style="width: 160px" placeholder="请输入"
                      size="mini"></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="el-cols">
                    <span>快捷发送数量:</span>
                    <el-input type="text" v-model="table_ceck[index].fastNums" style="width: 160px"
                      placeholder="(例：18;88;88)"></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="el-cols">
                    <span>功能属性：</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="el-cols">
                    <span>是否快捷礼物:</span>
                    <el-switch v-model="table_ceck[index].isFast" active-text="是" inactive-text="不是" :active-value="1"
                      :inactive-value="0"></el-switch>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="el-cols">
                    <span>是否展示礼物描述:</span>
                    <el-switch v-model="table_ceck[index].showGiftDesc" active-text="展示" inactive-text="不展示"
                      :active-value="1" :inactive-value="0"></el-switch>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="el-cols">
                    <span>礼物描述文案:</span>
                    <el-input type="text" v-model="table_ceck[index].giftDesc" style="width: 160px"
                      placeholder="请输入"></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="el-cols">
                    <span>礼物图片url:</span>
                    <UploadSingleImg v-model="table_ceck[index].giftDescIconUrl"
                      :on-upload="(file) => uploadFile(file, 'gift_resource/detail_icon/')" />
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="el-cols">
                    <span>或直接输入URL:</span>
                    <el-input v-model="table_ceck[index].giftDescIconUrl" style="width: 300px" placeholder="请输入图片URL"></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="el-cols" v-if="table_ceck[index].giftDescIconUrl">
                    <p style="word-break: break-all;width: 80%;">{{ table_ceck[index].giftDescIconUrl }}</p>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="el-cols">
                    <span style="width: 130px;">是否增加固定奖励:</span>
                    <el-input type="text" v-model="table_ceck[index].extraReward" style="width: 160px"
                      placeholder="请输入"></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="el-cols">
                    <span style="width: 130px;">礼物描述跳转的链接:</span>
                    <el-input type="text" v-model="table_ceck[index].giftDescUrl" style="width: 160px"
                      placeholder="请输入"></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="el-cols">
                    <span>是否全屏特效:</span>
                    <el-switch v-model="table_ceck[index].screenEffect" active-text="是" inactive-text="不是"
                      :active-value="1" :inactive-value="0"></el-switch>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="el-cols">
                    <span>是否全服通知:</span>
                    <el-switch v-model="table_ceck[index].serverNotification" active-text="是" inactive-text="不是"
                      :active-value="1" :inactive-value="0"></el-switch>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="el-cols">
                    <span>主播端展示:</span>
                    <el-switch v-model="table_ceck[index].hostShow" active-text="展示" inactive-text="不展示"
                      :active-value="1" :inactive-value="0"></el-switch>
                  </el-col>
                </el-row>
              </el-card>
            </div>
          </div>
        </div>
        <div v-else>
          <el-row>
            <el-col class="el-cols">
              <span>礼物图标:</span>
              <UploadSingleImg v-model="list.iconUrl" :on-upload="(file) => uploadFile(file, ' gift_resource/icon/')" />
              <span class="url" v-if="list.iconUrl">{{ list.iconUrl }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>礼物资源:</span>
              <UploadSingleImg v-model="list.resourceUrl"
                :on-upload="(file) => uploadFile(file, ' gift_resource/gift/')" />
              <span class="url" v-if="list.resourceUrl">{{ list.resourceUrl }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>礼物动画资源:</span>
              <UploadSingleImg v-model="list.originUrl"
                :on-upload="(file) => uploadFile(file, ' gift_resource/origin/')" />
              <span class="url" v-if="list.originUrl">{{ list.originUrl }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>融合礼物资源:</span>
              <UploadSingleImg v-model="list.fusionUrl"
                :on-upload="(file) => uploadFile(file, ' gift_resource/fusion/')" />
              <span class="url" v-if="list.fusionUrl">{{ list.fusionUrl }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>礼物动画时间:</span>
              <el-input type="number" v-model="list.len" style="width: 160px" placeholder="请输入"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="el-cols">
              <span>是否SVIP礼物:</span>
              <el-switch v-model="list.svip" active-text="是" inactive-text="不是" :active-value="1"
                :inactive-value="0"></el-switch>
            </el-col>
          </el-row>
        </div>

        <el-row class="buttom">
          <el-popconfirm v-if="est" title="确定创建吗？" @confirm="establish()">
            <el-button type="primary" slot="reference">创建</el-button>
          </el-popconfirm>
          <el-popconfirm v-else title="确定修改吗？" @confirm="editss()">
            <el-button type="primary" slot="reference">修改</el-button>
          </el-popconfirm>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="编辑" size="35%" :visible.sync="drawer_" :direction="direction" :before-close="handleClose_">
      <div class="add">
        <el-row>
          <el-col class="el-cols">
            <span>渠道:</span>
            <el-select v-model="row_list.channel" placeholder="请选择渠道" clearable="" filterable>
              <el-option v-for="(item, itemIndex) in channelList" v-bind:key="itemIndex" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>礼物类型:</span>
            <el-select style="width: 160px" v-model="row_list.isLuck" placeholder="">
              <el-option v-for="(item, itemIndex) in giftsTypeList" v-bind:key="itemIndex" :label="item.name"
                :value="item.value"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>礼物名字:</span>
            <el-input v-model="row_list.giftName" style="width: 160px" placeholder="请输入"></el-input>
          </el-col>
        </el-row>
        <el-row> </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>礼物价格:</span>
            <el-input v-model="row_list.realPrice" style="width: 160px" placeholder="请输入" :disabled="true"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>显示分类:</span>
            <el-select style="width: 160px" class="header-item" v-model="row_list.showType">
              <el-option v-for="(item, itemIndex) in showTypeList" :key="itemIndex" :label="item.name"
                :value="item.value"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>礼物排序权重:</span>
            <el-input type="number" v-model="row_list.orderId" style="width: 160px" placeholder="请输入"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>加载类型:</span>
            <el-select style="width: 160px" class="header-item" v-model="row_list.loadType">
              <el-option v-for="(item, itemIndex) in showLoadList" :key="itemIndex" :label="item.name"
                :value="item.value"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>是否上架:</span>
            <el-switch v-model="row_list.vail" active-text="上架" inactive-text="下架" :active-value="1"
              :inactive-value="0"></el-switch>
          </el-col>
        </el-row>
        <el-row style="margin-top: 50px;">
          <el-col class="el-cols">
            <span style="text-align: left;font-weight: bold;">礼物属性:</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols" :span="12">
            <span>是否活动礼物:</span>
            <el-switch v-model="row_list.activity" active-text="是" inactive-text="不是" :active-value="1"
              :inactive-value="0"></el-switch>
          </el-col>
        </el-row>
        <el-row>
          <div class="el-cols">
            <span>是否融合礼物:</span>
            <el-switch v-model="row_list.fusionSwitch" active-text="是" inactive-text="不是" :active-value="1"
              :inactive-value="0"></el-switch>
          </div>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>融合礼物头像类型:</span>
            <el-radio-group v-model="row_list.fusionType">
              <el-radio :label="0">不是</el-radio>
              <el-radio :label="1">单头像</el-radio>
              <el-radio :label="2">双头像</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>融合礼物展示对象:</span>
            <el-radio-group v-model="row_list.fusionShowType">
              <el-radio :label="1">发送者</el-radio>
              <el-radio :label="2">接收者</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>是否昵称展示:</span>
            <el-switch v-model="row_list.fusionNameSwitch" active-text="是" inactive-text="不是" :active-value="1"
              :inactive-value="0"></el-switch>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>是否id展示:</span>
            <el-switch v-model="row_list.fusionIdSwitch" active-text="是" inactive-text="不是" :active-value="1"
              :inactive-value="0"></el-switch>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>rid色值:</span>
            <el-input v-model="row_list.idColor" style="width: 160px" placeholder="请输入"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>昵称色值:</span>
            <el-input v-model="row_list.nameColor" style="width: 160px" placeholder="请输入"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>是否贵族:</span>
            <el-switch v-model="row_list.lord" active-text="是" inactive-text="不是" :active-value="1"
              :inactive-value="0"></el-switch>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>是否VIP:</span>
            <el-switch v-model="row_list.vip" active-text="是" inactive-text="不是" :active-value="1"
              :inactive-value="0"></el-switch>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>是否表白礼物:</span>
            <el-switch v-model="row_list.confession" active-text="是" inactive-text="不是" :active-value="1"
              :inactive-value="0"></el-switch>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>是否上公告:</span>
            <el-switch v-model="row_list.bulletin" active-text="是" inactive-text="不是" :active-value="1"
              :inactive-value="0"></el-switch>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>是否显示活动标签:</span>
            <el-switch v-model="row_list.activityLabel" active-text="是" inactive-text="不是" :active-value="1"
              :inactive-value="0"></el-switch>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>等级:</span>
            <el-input type="number" v-model="row_list.level" style="width: 160px" placeholder="请输入"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>是否SVIP礼物:</span>
            <el-switch v-model="row_list.svip" active-text="是" inactive-text="不是" :active-value="1"
              :inactive-value="0"></el-switch>
          </el-col>
        </el-row>
        <el-row>
          <el-card style="width: 100%;">
            <el-row>
              <el-col class="el-cols">
                <span style="font-weight: bold;text-align: left;">礼物场景:</span>
                <el-select style="width: 160px; margin-left: 10px;" v-model="row_list.giftType" placeholder="请选择礼物场景" clearable>
                  <el-option 
                    v-for="(item, itemIndex) in giftTypes.slice(1)" 
                    :key="itemIndex" 
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-checkbox v-if="row_list.ids && row_list.ids.length > 1" style="margin-left: 10px" v-model="modifyGiftType">是否修改礼物场景</el-checkbox>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="el-cols">
                <span>礼物分成比:</span>
                <el-input type="number" v-model="row_list.gainRatio" style="width: 160px" placeholder="请输入"
                  size="mini"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="el-cols">
                <span>快捷发送数量:</span>
                <el-input type="text" v-model="row_list.fastNums" style="width: 160px"
                  placeholder="(例：18;88;88)"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="el-cols">
                <span>功能属性：</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="el-cols">
                <span>是否快捷礼物:</span>
                <el-switch v-model="row_list.isFast" active-text="是" inactive-text="不是" :active-value="1"
                  :inactive-value="0"></el-switch>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="el-cols">
                <span>是否展示礼物描述:</span>
                <el-switch v-model="row_list.showGiftDesc" active-text="展示" inactive-text="不展示" :active-value="1"
                  :inactive-value="0"></el-switch>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="el-cols">
                <span>礼物描述文案:</span>
                <el-input type="text" v-model="row_list.giftDesc" style="width: 160px" placeholder="请输入"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="el-cols">
                <span>礼物ID:</span>
                <el-input type="number" v-model="row_list.giftId" style="width: 160px" placeholder="请输入"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="el-cols">
                <span>定制礼物绑定RID:</span>
                <el-input v-model="row_list.customizedRid" style="width: 160px" placeholder="请输入定制礼物绑定RID" clearable></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="el-cols">
                <span>礼物图片url:</span>
                <UploadSingleImg v-model="row_list.giftDescIconUrl"
                  :on-upload="(file) => uploadFile(file, 'gift_resource/detail_icon/')" />
              </el-col>
            </el-row>
            <el-row>
              <el-col class="el-cols">
                <span>或直接输入URL:</span>
                <el-input v-model="row_list.giftDescIconUrl" style="width: 300px" placeholder="请输入图片URL"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="el-cols" v-if="row_list.giftDescIconUrl">
                <p style="word-break: break-all;width: 80%;">{{ row_list.giftDescIconUrl }}</p>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="el-cols">
                <span style="width: 130px;">是否增加固定奖励:</span>
                <el-input type="text" v-model="row_list.extraReward" style="width: 160px"
                  placeholder="请输入"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="el-cols">
                <span style="width: 130px;">礼物描述跳转的链接:</span>
                <el-input type="text" v-model="row_list.giftDescUrl" style="width: 160px" placeholder="请输入"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="el-cols">
                <span>是否全屏特效:</span>
                <el-switch v-model="row_list.screenEffect" active-text="是" inactive-text="不是" :active-value="1"
                  :inactive-value="0"></el-switch>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="el-cols">
                <span>是否全服通知:</span>
                <el-switch v-model="row_list.serverNotification" active-text="是" inactive-text="不是" :active-value="1"
                  :inactive-value="0"></el-switch>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="el-cols">
                <span>主播端展示:</span>
                <el-switch v-model="row_list.hostShow" active-text="展示" inactive-text="不展示" :active-value="1"
                  :inactive-value="0"></el-switch>
              </el-col>
            </el-row>
          </el-card>
        </el-row>
        <el-row class="buttom">
          <el-popconfirm title="确定编辑吗？" @confirm="edits()">
            <el-button type="primary" slot="reference">编辑</el-button>
          </el-popconfirm>
        </el-row>
      </div>
    </el-drawer>
    <el-dialog :visible.sync="dialogVisible">
      <el-input type="textarea" :rows="5" autosize placeholder="请输入内容" v-model="textarea">
      </el-input>
      <el-button @click="copyData">确认</el-button>
    </el-dialog>
    <!-- 表格 -->
    <el-row class="user-options">
      <el-table height="60vh" :data="dayChatDetailData" style="width: 100%" v-loading="login1" border
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="giftId" label="礼物Id" align="center">
        </el-table-column>
        <el-table-column prop="customizedRid" label="定制礼物绑定RID" align="center">
        </el-table-column>
        <el-table-column prop="channel" label="渠道" align="center">
        </el-table-column>
        <el-table-column prop="giftName" label="礼物名字" align="center">
        </el-table-column>
        <el-table-column prop="showType" label="礼物显示类型" align="center">
          <template slot-scope="scope">
            {{
              showTypeList.find((item) => item.value == scope.row.showType)
                ?.name || ''
            }}
          </template>
        </el-table-column>
        <el-table-column prop="realPrice" label="礼物价格" align="center">
          <template slot-scope="scope">
            {{ scope.row.realPrice || scope.row.price }}
          </template>
        </el-table-column>
        <el-table-column prop="gainRatio" label="主播分成" align="center">
        </el-table-column>
        <el-table-column prop="iconUrl" label="图标url" align="center">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 100px" :src="scope.row.iconUrl"
              :preview-src-list="[scope.row.iconUrl]"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="orderId" label="排序id" align="center">
        </el-table-column>
        <el-table-column prop="vail" label="是否上架" align="center">
          <template slot-scope="scope">
            {{ scope.row.vail == '0' ? '下架' : '上架' }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="生成时间" align="center">
        </el-table-column>
        <el-table-column prop="isLuck" label="礼物类型" align="center">
          <template slot-scope="scope">
            {{ giftsTypeList.find((item) => item.value == scope.row.isLuck)?.label || '' }}
          </template>
        </el-table-column>
        <el-table-column prop="giftType" label="礼物场景" align="center">
          <template slot-scope="scope">
            {{ gifttupe(scope.row.giftType) }}
          </template>
        </el-table-column>
        <el-table-column prop="loadType" label="礼物加载类型" align="center">
          <template slot-scope="scope">
            {{
              showLoadList.find((item) => item.value == scope.row.loadType)
                ?.name || ''
            }}
          </template>
        </el-table-column>
        <el-table-column prop="isFast" label="是否快捷礼物" align="center">
          <template slot-scope="scope">
            {{ scope.row.isFast == 1 ? '是' : '不是' }}
          </template>
        </el-table-column>
        <el-table-column prop="fusionSwitch" label="是否融合礼物" align="center">
          <template slot-scope="scope">
            {{ scope.row.fusionSwitch == 1 ? '是' : '不是' }}
          </template>
        </el-table-column>
        <el-table-column prop="activity	" label="是否活动礼物" align="center">
          <template slot-scope="scope">
            {{ scope.row.activity == '0' ? '不是' : '是' }}
          </template>
        </el-table-column>

        <el-table-column prop="fastNums" label="快捷发送数量" align="center">
        </el-table-column>
        <el-table-column prop="showGiftDesc" label="是否展示礼物描述" align="center">
          <template slot-scope="scope">
            {{ scope.row.showGiftDesc == '0' ? '不展示' : '展示' }}
          </template>
        </el-table-column>
        <el-table-column prop="giftDescUrl" label="礼物图片url" align="center">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 100px" :src="scope.row.giftDescUrl"
              :preview-src-list="[scope.row.giftDescUrl]"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="giftDescIconUrl" label="礼物描述详情图标" align="center">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 100px" :src="scope.row.giftDescIconUrl"
              :preview-src-list="[scope.row.giftDescIconUrl]"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="giftDesc" label="礼物描述" align="center">
        </el-table-column>
        <el-table-column prop="giftDescUrl" label="礼物描述跳转链接" align="center">
        </el-table-column>
        <el-table-column prop="screenEffect" label="是否全屏特效" align="center">
          <template slot-scope="scope">
            {{ scope.row.screenEffect == '0' ? '不是' : '是' }}
          </template>
        </el-table-column>
        <el-table-column prop="serverNotification" label="是否全服通知" align="center">
          <template slot-scope="scope">
            {{ scope.row.serverNotification == '0' ? '不是' : '是' }}
          </template>
        </el-table-column>
        <el-table-column prop="hostShow" label="主播端展示" align="center">
          <template slot-scope="scope">
            {{ scope.row.hostShow == '0' ? '不展示' : '展示' }}
          </template>
        </el-table-column>
        <el-table-column prop="lord" label="是否贵族" align="center">
          <template slot-scope="scope">
            {{ scope.row.lord == '0' ? '不是' : '是' }}
          </template>
        </el-table-column>
        <el-table-column prop="vip" label="是否VIP" align="center">
          <template slot-scope="scope">
            {{
              scope.row.vip == '0' ? '不是' : scope.row.vip == '1' ? '是' : ''
            }}
          </template>
        </el-table-column>
        <el-table-column prop="confession" label="是否表白礼物" align="center">
          <template slot-scope="scope">
            {{ scope.row.confession == '1' ? '是' : '不是' }}
          </template>
        </el-table-column>
        <el-table-column prop="bulletin" label="是否上公告" align="center">
          <template slot-scope="scope">
            {{ scope.row.bulletin == '1' ? '是' : '不是' }}
          </template>
        </el-table-column>
        <el-table-column prop="activityLabel" label="是否显示活动标签" align="center">
          <template slot-scope="scope">
            {{ scope.row.activityLabel == '1' ? '是' : '不是' }}
          </template>
        </el-table-column>
        <el-table-column prop="level" label="等级" align="center">
        </el-table-column>
        <el-table-column prop="svip" label="是否SVIP礼物" align="center">
          <template slot-scope="scope">
            {{ scope.row.svip == '0' ? '不是' : scope.row.svip == '1' ? '是' : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="mtime" :formatter="formatDate" label="修改时间" align="center">
        </el-table-column>
        <el-table-column prop="operator" label="操作人" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="350">
          <template slot-scope="scope">
            <el-popconfirm style="margin-right: 10px;" title="确定上架吗？" @confirm="modify(scope.row, 1)">
              <el-button type="primary" slot="reference">上架</el-button>
            </el-popconfirm>
            <el-popconfirm style="margin-right: 10px;" title="确定下架吗？" @confirm="modify(scope.row, 0)">
              <el-button type="primary" slot="reference">下架</el-button>
            </el-popconfirm>
            <el-button type="primary" @click="copys(scope.row.giftId)">复制</el-button>
            <el-button type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button type="primary" id="btn" @click="copy(scope.row)">复制到测试服</el-button>
            <el-button type="warning" @click="changeGiftPrice(scope.row)">修改礼物价格</el-button>
            <div style="margin-top: 20px">
              <el-button type="primary" @click="edit(scope.row, 1)">资源编辑</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 分页 -->
    <el-row class="user-options">
      <el-pagination :current-page.sync="page" layout="total, prev, pager, next" background
        @current-change="handleCurrentChange" :total="total" :page-size="30" class="pagination"></el-pagination>
    </el-row>
    
    <!-- 修改礼物余额弹窗 -->
    <el-dialog title="修改礼物余额" :visible.sync="changePriceDialogVisible" width="500px">
      <el-form :model="changePriceForm" label-width="120px">
        <el-form-item label="礼物ID:">
          <span>{{ changePriceForm.giftId }}</span>
        </el-form-item>
        <el-form-item label="礼物名字:">
          <span>{{ changePriceForm.giftName }}</span>
        </el-form-item>
        <el-form-item label="图标URL:">
          <el-image style="width: 80px; height: 80px" :src="changePriceForm.iconUrl"
            :preview-src-list="[changePriceForm.iconUrl]"></el-image>
        </el-form-item>
        <el-form-item label="礼物价格:">
          <el-input v-model="changePriceForm.realPrice" type="number" placeholder="请输入新的礼物价格"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changePriceDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmChangePrice">确认</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { newChannelList } from '@/utils/normalApi.js'
import UploadSingleImg from '@/components/UploadSingleImg/UploadSingleImg'
import { type } from '@/store/index.js'
import Clipboard from 'clipboard'
export default {
  components: {
    UploadSingleImg
  },
  data() {
    return {
      activityLabel: null,
      isText: type,
      textarea: '',
      orderId: null,
      giftTypelist: null,
      dialogVisible: false,
      priceOrder: '',
      showType: null,
      loadType: null,
      showTypeList: [],
      showLoadList: [],
      giftTypelists: [
        {
          label: '全部',
          value: null,
        },
        {
          label: '活动礼物',
          value: 1,
        },
        {
          label: '告白礼物',
          value: 2,
        },
        {
          label: '融合礼物',
          value: 3,
        },
        {
          label: '贵族礼物',
          value: 4,
        },

      ],
      orderlist: [
        {
          label: '默认排序',
          value: null,
        },
        {
          label: '升序',
          value: 'asc',
        },
        {
          label: '降序',
          value: 'desc',
        },
      ],
      priceOrderType: [
        {
          label: '默认排序',
          value: '',
        },
        {
          label: '价格升序',
          value: 'asc',
        },
        {
          label: '价格降序',
          value: 'desc',
        },
      ],
      est: true,
      giftName: '', //礼物名称
      isLuckGift: null, //礼物类型
      newChangeVal: {
        lord: 0,
        vip: 0,
        level: 0,
      },
      isLuckGifts: [
        {
          label: '全部',
          value: null,
        },
        {
          label: '幸运礼物',
          value: 1,
        },
        {
          label: '普通礼物',
          value: 0,
        },
      ],
      giftType: null, //礼物场景
      giftTypes: [
        {
          label: '全部',
          value: null,
        },
        {
          label: '私聊',
          value: 0,
        },
        {
          label: '视频通话',
          value: 1,
        },
        {
          label: '假电话',
          value: 2,
        },
        {
          label: 'live',
          value: 3,
        },
        {
          label: '房间礼物',
          value: 4,
        },
        {
          label: '礼物钻石类型',
          value: 5,
        },
        {
          label: '视频送礼',
          value: 6,
        },
      ],
      vail: null, //礼物场景
      vails: [
        {
          label: '全部',
          value: null,
        },
        {
          label: '上架',
          value: 1,
        },
        {
          label: '下架',
          value: 0,
        },
      ],
      checked: false,
      list: {
        iconUrl: '', //礼物图标
        resourceUrl: '', //.gift 礼物资源
        originUrl: '', //.webp 礼物动图
        len: 0, //礼物动画时间
        showType: null, //礼物显示类型
        loadType: null, //礼物加载类型
        isLuck: 0, //是否为幸运礼物  1是 0不是
        giftName: '', //礼物名字
        giftDescUrl: '',
        realPrice: '0', //礼物价格
        orderId: 0, //礼物权重
        vail: 1, //是否上架 0下架 1上架
        channelList: undefined,
        activity: 0,
        activityLabel: 0,
        lord: 0,
        vip: 0,
        fusionUrl: '',
        idColor: '',
        nameColor: '',
        fusionSwitch: 0,
        fusionType: 0,
        fusionNameSwitch: 0,
        fusionIdSwitch: 0,
        fusionShowType: 1,
        level: 0,
        confession: 0,
        bulletin: 0,
        svip: 0,
        giftSceneList: [
          //礼物场景列表
          {
            giftScene: 0, //礼物场景 0 私聊 1视频通话 2假电话 3live
            gainRatio: 0, //主播分成
          },
        ],
      },
      row_list: {},
      msg: false,
      drawer: false,
      direction: 'rtl',
      // 加载
      login1: false,
      // 分引
      page: 1,
      total: 0,
      table_ceck: Array(7).fill().map(() => ({
        checkList: false,
        gainRatio: 0,
        isFast: 0,
        fastNums: '',
        showGiftDesc: 0,
        giftDesc: '',
        giftDescUrl: '',
        giftDescIconUrl: '',
        extraReward: 0,
        screenEffect: 0,
        serverNotification: 0,
        hostShow: 0,
        lord: 0,
        vip: 0,
        level: 0
      })),
      // 表格数据
      dayChatDetailData: [],
      drawer_: false,
      activity: null,
      channel: null,
      channelList: [],
      giftId: '',
      customizedRid: null,
      moreEditList: [],
      giftsTypeList:[],
      modifyGiftType: false, // 是否修改礼物场景
      originalGiftTypes: {}, // 保存每个礼物原来的giftType值 {id: giftType}
      // 修改礼物余额相关
      changePriceDialogVisible: false,
      changePriceForm: {
        id: null,
        giftId: '',
        giftName: '',
        iconUrl: '',
        realPrice: ''
      }
    }
  },
  watch: {
    checked: function (val) {
      if (val) {
        this.list.channelList = this.channelList.map((item) => item.value)
      } else {
        this.list.channelList = []
      }
    },
  },
  async created() {
    this.getDayChatDetai()
    this.getShowType()
    this.getLoadType()
    this.getSignType()
    this.channelList = await newChannelList()
  },
  methods: {
    // 获取常量
    async getSignType() {
      const { data: res } = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.const_all,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          className: 'com.quhong.constant.activity.luckyGift.LuckyGiftSonPoolConstant',
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.giftsTypeList = res.data
      }
    },
    formatDate(row, column) {
      // 获取单元格数据
      const timestamp = row[column.property]
      if (timestamp == null || timestamp === 0) {
        return '-'
      }
      // 如果是秒级时间戳，转换为毫秒
      const data = timestamp * 1000
      const dt = new Date(data)
      
      // 使用 UTC 方法获取时间，然后加上8小时转换为UTC+8
      let year = dt.getUTCFullYear()
      let month = dt.getUTCMonth() + 1
      let date = dt.getUTCDate()
      let hours = dt.getUTCHours() + 8
      const minutes = dt.getUTCMinutes()
      const seconds = dt.getUTCSeconds()
      
      // 处理跨日情况
      if (hours >= 24) {
        hours -= 24
        date += 1
        // 检查是否需要跨月
        const daysInMonth = new Date(year, month, 0).getDate()
        if (date > daysInMonth) {
          date = 1
          month += 1
          // 检查是否需要跨年
          if (month > 12) {
            month = 1
            year += 1
          }
        }
      }
      
      // 格式化输出
      return `${year}-${String(month).padStart(2, '0')}-${String(date).padStart(2, '0')} ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    },
    handleSelectionChange(section) {
      this.moreEditList = section
    },
    async uploadFile(file, dir) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('cover', 0)
      formData.append('dir', dir)
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formData
      )
      return { code: res.code, url: res.data }
    },
    copy(info) {
      let infos = JSON.stringify({ list: [info] })
      let clipboard = new Clipboard('#btn', {
        text: function () {
          //返回字符串
          return infos
        },
      })
      clipboard.on('success', () => {
        //复制成功
        this.$message('复制成功')
      })
    },
    async copyData() {
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_gift_copy,
        data: this.textarea,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res.code != 0) {
        return this.$message(res.msg)
      } else {
        this.$message('导入成功')
        this.dialogVisible = false
        this.textarea = ''
        this.getDayChatDetai()
      }
    },
    edit(row, num) {
      this.newChangeVal.lord = row.lord
      this.newChangeVal.vip = row.vip
      this.newChangeVal.level = row.level
      if (num) {
        this.drawer = true
        this.est = false
        this.list = row
        return
      }
      row.screenEffect = +row.screenEffect
      this.row_list = JSON.parse(JSON.stringify(row))
      this.row_list.currentChannel = row.channel
      this.row_list.ids = [row.id]
      this.modifyGiftType = false // 初始化勾选状态
      this.originalGiftTypes = {} // 单个编辑时清空
      this.drawer_ = true
    },
    moreEdit() {
      if (this.moreEditList.length <= 0) return this.$message('请选择要编辑的礼物')
      const row = this.moreEditList[0]
      const idList = this.moreEditList.map((item) => item.id)
      row.screenEffect = +row.screenEffect
      this.row_list = JSON.parse(JSON.stringify(row))
      this.row_list.currentChannel = row.channel
      this.row_list.ids = idList
      this.modifyGiftType = false // 初始化勾选状态
      // 保存每个礼物原来的giftType值
      this.originalGiftTypes = {}
      this.moreEditList.forEach((item) => {
        this.originalGiftTypes[item.id] = item.giftType
      })
      this.drawer_ = true
    },
    async moreChangeEdit(vail = 0) {
      if (this.moreEditList.length <= 0) return this.$message('请选择要编辑的礼物')
      const list = this.moreEditList.map((item) => item.id)
      const { data: res } = await this.$axios({
        method: 'POST',
        url: this.$store.getters.path.config_gift_changeGiftStatus,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: {
          idList: list,
          vail,
        },
      })
      if (res.code != 0) return this.$message(res.msg)
      this.$message.success(res.msg)

      this.getDayChatDetai()
    },
    async edits() {
      if (this.row_list.currentChannel == this.row_list.channel)
        this.row_list.channel = null
      
      // 如果是批量编辑且没有勾选"是否修改礼物场景"，需要为每个礼物单独调用API保持原值
      const isBatchEdit = this.row_list.ids && this.row_list.ids.length > 1
      const shouldKeepOriginalGiftType = isBatchEdit && !this.modifyGiftType
      
      if (shouldKeepOriginalGiftType) {
        // 批量编辑且未勾选：为每个礼物单独调用API，保持原来的giftType
        const baseData = {
          giftName: this.row_list.giftName,
          isLuck: this.row_list.isLuck,
          orderId: this.row_list.orderId,
          showType: this.row_list.showType,
          loadType: this.row_list.loadType,
          gainRatio: this.row_list.gainRatio,
          isFast: this.row_list.isFast,
          fastNums: this.row_list.fastNums,
          showGiftDesc: this.row_list.showGiftDesc,
          giftDesc: this.row_list.giftDesc,
          giftDescUrl: this.row_list.giftDescUrl,
          giftDescIconUrl: this.row_list.giftDescIconUrl,
          extraReward: this.row_list.extraReward,
          screenEffect: this.row_list.screenEffect,
          serverNotification: this.row_list.serverNotification,
          giftId: this.row_list.giftId,
          customizedRid: this.row_list.customizedRid || null,
          hostShow: this.row_list.hostShow,
          channel: this.row_list.channel,
          activity: this.row_list.activity,
          confession: this.row_list.confession,
          bulletin: this.row_list.bulletin,
          activityLabel: this.row_list.activityLabel,
          fusionSwitch: this.row_list.fusionSwitch || 0,
          fusionNameSwitch: this.row_list.fusionNameSwitch || 0,
          fusionIdSwitch: this.row_list.fusionIdSwitch || 0,
          fusionType: this.row_list.fusionType || 0,
          fusionShowType: this.row_list.fusionShowType || 1,
          fusionUrl: this.row_list.fusionUrl || '',
          idColor: this.row_list.idColor || '',
          nameColor: this.row_list.nameColor || '',
          resourceId: this.row_list.resourceId || '',
          lord: this.newChangeVal.lord == this.row_list.lord ? null : this.row_list.lord,
          vip: this.newChangeVal.vip == this.row_list.vip ? null : this.row_list.vip,
          level: this.newChangeVal.level == this.row_list.level ? null : Number(this.row_list.level),
          svip: this.row_list.svip,
        }
        
        // 为每个礼物单独调用API
        const promises = this.row_list.ids.map(id => {
          const originalGiftType = this.originalGiftTypes[id]
          return this.$axios({
            method: 'POST',
            url: this.$store.getters.path.config_gift_changeGiftConfig,
            withCredentials: true,
            params: {
              username: this.$store.getters.username,
              token: this.$store.getters.token,
            },
            data: {
              ids: [id],
              ...baseData,
              giftType: originalGiftType, // 使用原来的giftType值
            },
          })
        })
        
        try {
          const results = await Promise.all(promises)
          const failedResult = results.find(res => res.data.code != 0)
          if (failedResult) {
            return this.$message.error(failedResult.data.msg || '批量更新失败')
          }
          this.$message.success('批量更新成功')
        } catch (error) {
          return this.$message.error('批量更新失败，请重试')
        }
      } else {
        // 单个编辑或批量编辑且勾选了：正常调用API
        const { data: res } = await this.$axios({
          method: 'POST',
          url: this.$store.getters.path.config_gift_changeGiftConfig,
          withCredentials: true,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
          data: {
            ids: this.row_list.ids,
            giftName: this.row_list.giftName,
            isLuck: this.row_list.isLuck,
            giftType: this.row_list.giftType, // 单个编辑或勾选时传递giftType
            orderId: this.row_list.orderId,
            showType: this.row_list.showType,
            loadType: this.row_list.loadType,
            gainRatio: this.row_list.gainRatio,
            isFast: this.row_list.isFast,
            fastNums: this.row_list.fastNums,
            showGiftDesc: this.row_list.showGiftDesc,
            giftDesc: this.row_list.giftDesc,
            giftDescUrl: this.row_list.giftDescUrl,
            giftDescIconUrl: this.row_list.giftDescIconUrl,
            extraReward: this.row_list.extraReward,
            screenEffect: this.row_list.screenEffect,
            serverNotification: this.row_list.serverNotification,
            giftId: this.row_list.giftId,
            customizedRid: this.row_list.customizedRid || null,
            hostShow: this.row_list.hostShow,
            channel: this.row_list.channel,
            activity: this.row_list.activity,
            confession: this.row_list.confession,
            bulletin: this.row_list.bulletin,
            activityLabel: this.row_list.activityLabel,
            fusionSwitch: this.row_list.fusionSwitch || 0,
            fusionNameSwitch: this.row_list.fusionNameSwitch || 0,
            fusionIdSwitch: this.row_list.fusionIdSwitch || 0,
            fusionType: this.row_list.fusionType || 0,
            fusionShowType: this.row_list.fusionShowType || 1,
            fusionUrl: this.row_list.fusionUrl || '',
            idColor: this.row_list.idColor || '',
            nameColor: this.row_list.nameColor || '',
            resourceId: this.row_list.resourceId || '',
            lord: this.newChangeVal.lord == this.row_list.lord ? null : this.row_list.lord,
            vip: this.newChangeVal.vip == this.row_list.vip ? null : this.row_list.vip,
            level: this.newChangeVal.level == this.row_list.level ? null : Number(this.row_list.level),
            svip: this.row_list.svip,
          },
        })
        if (res.code != 0) return this.$message(res.msg)
        this.$message.success(res.msg)
      }
      
      this.drawer_ = false
      this.getDayChatDetai()
    },
    async editss() {
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.config_gift_changeGiftResource,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          resourceId: this.list.resourceId,
          iconUrl: this.list.iconUrl,
          resourceUrl: this.list.resourceUrl,
          channel: this.list.channel,
          originUrl: this.list.originUrl,
          len: this.list.len,
          fusionSwitch: this.list.fusionSwitch,
          fusionNameSwitch: this.list.fusionNameSwitch,
          fusionIdSwitch: this.list.fusionIdSwitch,
          fusionType: this.list.fusionType,
          fusionShowType: this.list.fusionShowType,
          fusionUrl: this.list.fusionUrl,
          idColor: this.list.idColor,
          nameColor: this.list.nameColor,
          svip: this.list.svip,
        },
      })
      if (res.code != 0) return this.$message(res.msg)
      this.$message.success(res.msg)
      this.drawer = false
      this.getDayChatDetai()
    },
    gifttupe(row) {
      return this.giftTypes.find((item) => item.value == row).label || ''
    },

    // 查询列表
    async getDayChatDetai() {
      this.login1 = true
      const { data: res } = await this.$axios({
        method: 'POST',
        url: this.$store.getters.path.config_gift_query,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: {
          giftName: this.giftName,
          isLuckGift: this.isLuckGift,
          giftType: this.giftType,
          vail: this.vail,
          channel: this.channel,
          activity: this.activity,
          giftId: this.giftId,
          customizedRid: this.customizedRid,
          page: this.page,
          priceOrder: this.priceOrder,
          showType: this.showType,
          loadType: this.loadType,
          orderId: this.orderId,
          giftTypeList: this.giftTypelist && this.giftTypelist.length > 0 ? this.giftTypelist.filter(item => item !== null) : null,
          activityLabel: this.activityLabel,
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.dayChatDetailData = res.data.data
      this.total = res.data.total
    },
    // 创建
    async establish() {
      let giftSceneList = []
      this.table_ceck.map((ele, i) => {
        if (ele.checkList) {
          giftSceneList.push({
            giftScene: i,
            gainRatio: ele.gainRatio,
            isFast: ele.isFast,
            fastNums: ele.fastNums,
            showGiftDesc: ele.showGiftDesc,
            giftDesc: ele.giftDesc,
            giftDescUrl: ele.giftDescUrl,
            giftDescIconUrl: ele.giftDescIconUrl,
            extraReward: ele.extraReward,
            screenEffect: ele.screenEffect,
            serverNotification: ele.serverNotification,
            hostShow: ele.hostShow,
            lord: ele.lord, // 是否贵族 0 否 1是
            vip: ele.vip, // 是否贵族 0 否 1是
            level: ele.level, // 等级
          })
        }
      })
      let url =
        this.$store.getters.path.config_gift_add +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      let data = {
        iconUrl: this.list.iconUrl,
        resourceUrl: this.list.resourceUrl,
        originUrl: this.list.originUrl,
        len: Number(this.list.len),
        showType: Number(this.list.showType),
        loadType: Number(this.list.loadType),
        realPrice: this.list.realPrice,
        orderId: Number(this.list.orderId),
        isLuck: this.list.isLuck,
        channelList: this.list.channelList,
        activity: this.list.activity,
        activityLabel: this.list.activityLabel,
        giftName: this.list.giftName,
        vail: this.list.vail,
        giftSceneList: giftSceneList,
        lord: this.list.lord,
        vip: this.list.vip,
        fusionSwitch: this.list.fusionSwitch,
        fusionNameSwitch: this.list.fusionNameSwitch,
        fusionIdSwitch: this.list.fusionIdSwitch,
        fusionType: this.list.fusionType,
        fusionShowType: this.list.fusionShowType,
        fusionUrl: this.list.fusionUrl,
        idColor: this.list.idColor,
        nameColor: this.list.nameColor,
        level: Number(this.list.level),
        confession: this.list.confession,
        bulletin: this.list.bulletin,
        svip: this.list.svip,
      }

      const { data: res } = await this.$axios.post(url, data)
      if (res.code != 0) return this.$message.error(res.msg)
      this.$message.success(res.msg)
      this.handleClose()
      this.getDayChatDetai()
    },
    cre() {
      this.drawer = true
      this.est = true
    },
    // 修改
    async modify(row, vail) {
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.config_gift_changeStatus,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          vail: vail,
          id: row.id,
        },
      })
      if (res.code != 0) return this.$message(res.msg)
      this.$message.success(res.msg)
      this.getDayChatDetai()
    },
    async copys(id) {
      const { data: res } = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.config_gift_copys,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          giftId: id,
        },
      })
      if (res.code != 0) return this.$message(res.msg)
      this.getDayChatDetai()
    },
    // 分页
    handleCurrentChange() {
      this.getDayChatDetai()
    },
    handleClose() {
      this.drawer = false
      this.checked = false
      this.list = {
        iconUrl: '', //礼物图标
        resourceUrl: '', //.gift 礼物资源
        originUrl: '', //.webp 礼物动图
        len: 0, //礼物动画时间
        isLuck: 0, //是否为幸运礼物  1是 0不是
        giftName: '', //礼物名字
        realPrice: 0, //礼物价格
        orderId: 0, //礼物权重
        vail: 1, //是否上架 0下架 1上架
        channelList: undefined,
        activity: 0,
        activityLabel: 0,
        confession: 0,
        bulletin: 0,
        svip: 0,
        showType: null,
        loadType: null,
        giftSceneList: [
          //礼物场景列表
          {
            giftScene: 0, //礼物场景 0 私聊 1视频通话 2假电话 3live
            gainRatio: 0, //主播分成
          },
        ],
      }
      this.table_ceck = Array(this.giftTypes.length).fill().map(() => ({
        checkList: false,
        gainRatio: 0,
        isFast: 0,
        fastNums: '',
        showGiftDesc: 0,
        giftDesc: '',
        giftDescUrl: '',
        giftDescIconUrl: '',
        extraReward: 0,
        screenEffect: 0,
        serverNotification: 0,
        hostShow: 0,
        lord: 0,
        vip: 0,
        level: 0
      }))
    },
    handleClose_() {
      this.drawer_ = false
      this.modifyGiftType = false // 关闭弹窗时重置勾选状态
      this.originalGiftTypes = {} // 清空保存的原始值
    },
    // 获取显示类型选项
    async getShowType() {
      const { data: res } = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.const_all,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          className: 'com.quhong.enums.GiftShowTypeForAdmin',
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.showTypeList = res.data
      }
    },
    // 获取加载类型选项
    async getLoadType() {
      const { data: res } = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.const_all,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          className: 'com.quhong.enums.GiftLoadType',
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.showLoadList = res.data
      }
    },
    
    // 修改礼物余额相关方法
    changeGiftPrice(row) {
      this.changePriceForm = {
        id: row.id,
        giftId: row.giftId,
        giftName: row.giftName,
        iconUrl: row.iconUrl,
        realPrice: row.realPrice || row.price || ''
      }
      this.changePriceDialogVisible = true
    },
    
    async confirmChangePrice() {
      // 二次确认
      try {
        await this.$confirm('确定要修改这个礼物的价格吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch {
        return
      }
      
      if (!this.changePriceForm.realPrice || this.changePriceForm.realPrice <= 0) {
        return this.$message.error('请输入有效的礼物价格')
      }
      
             try {
         const { data: res } = await this.$axios({
           method: 'GET',
           url: this.$store.getters.path.config_gift_change_price,
           withCredentials: true,
           params: {
             username: this.$store.getters.username,
             token: this.$store.getters.token,
             id: this.changePriceForm.id,
             realPrice: this.changePriceForm.realPrice
           }
         })
        
        if (res.code != 0) {
          return this.$message.error(res.msg)
        }
        
        this.$message.success('礼物价格修改成功')
        this.changePriceDialogVisible = false
        this.getDayChatDetai() // 刷新列表
      } catch (error) {
        this.$message.error('修改失败，请重试')
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    >* {
      margin: 5px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}

.add {
  .el-row {
    padding: 0 30px;

    span {
      display: block;
      margin: 0 0 10px;
    }

    .el-input {
      width: 150px;
    }

    >.el-cols {
      display: flex;
      align-items: center;

      >span {
        width: 120px;
        height: max-content;
        text-align: right;
        margin: 0 10px 0 0;

        &.url {
          margin: 0 0 0 5px;
          font-size: 10px;
        }
      }
    }
  }

  .buttom {
    display: flex;
    justify-content: flex-end;
    margin: 0 100px;
  }
}

.row {
  font-size: 14px;

  >div {
    display: flex;
    padding: 0 30px;
    align-items: center;
    flex-wrap: wrap;
    margin: 0 0 20px;

    span {
      white-space: nowrap;
      padding: 0 5px;
    }

    >div {
      margin: 5px;
      display: flex;
      align-items: center;
    }
  }
}
</style>
